exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ResizableContainer_resizable_container__1ojQs {\n  flex: 1 1;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  min-width: 0;\n  min-height: 0; }\n  .ResizableContainer_resizable_container__1ojQs.ResizableContainer_horizontal__3iaYA {\n    flex-direction: row; }\n  .ResizableContainer_resizable_container__1ojQs .ResizableContainer_wrapper__2mxJZ {\n    flex: 1 1;\n    display: flex;\n    flex-direction: column;\n    align-items: stretch;\n    overflow: hidden; }\n    .ResizableContainer_resizable_container__1ojQs .ResizableContainer_wrapper__2mxJZ.ResizableContainer_horizontal__3iaYA {\n      flex-direction: row; }\n", ""]);

// Exports
exports.locals = {
	"themeDark": "#242424",
	"themeNormal": "#393939",
	"themeLight": "#505050",
	"colorFont": "#bbbbbb",
	"colorShadow": "rgba(0, 0, 0, 0.2)",
	"colorOverlay": "rgba(255, 255, 255, 0.1)",
	"colorAlert": "#f3bd58",
	"colorSelected": "#2962ff",
	"colorPatched": "#c51162",
	"colorHighlight": "#29d",
	"colorActive": "#00e676",
	"lineHeight": "32px",
	"fontSizeNormal": "12px",
	"fontSizeLarge": "14px",
	"resizable_container": "ResizableContainer_resizable_container__1ojQs",
	"horizontal": "ResizableContainer_horizontal__3iaYA",
	"wrapper": "ResizableContainer_wrapper__2mxJZ"
};